import { Outlet } from 'react-router-dom'

import { CatalogDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function CatalogDetail() {
  const { data, error, loading } = usePageQuery()
  const training = data?.trainings.trainingsConnection.nodes.at(0)

  return (
    <ResponsivePage.Body showHeader={false} loading={loading} error={error}>
      <Outlet
        context={{
          training,
          classFiles: data?.trainings.trainingClassFilesConnection.nodes,
          trainingFiles: data?.trainings.trainingFilesConnection.nodes,
          certificates: data?.trainings.trainingMembershipsConnection.nodes.flatMap(
            (membership) => membership.trainingMembershipFilesConnection.nodes
          ),
        }}
      />
    </ResponsivePage.Body>
  )
}

function usePageQuery() {
  const { trainingId } = useStrictParams<'trainingId'>()
  const {
    employee: { id: employeeId },
  } = useCurrentSession()
  return useQuery(CatalogDetailDocument, {
    variables: { employeeId, trainingId: Number(trainingId) },
  })
}
